import React from 'react'
import StoryCover from './StoryCover'
import { Grid } from '@material-ui/core'
import StoryLinkUrl from './StoryLinkUrl'

const StoryFactory = (story, index) => {
  if(story.storyType === 'imageUrl'){
    return <StoryLinkUrl story={story} index={index} />
  }

  return <StoryCover story={story} index={index} />
} 

function NonFeaturedStoriesList({ stories, index }) {
  
  stories = stories.map(story => <Grid item xs key={story._id}>{StoryFactory(story, index)}</Grid>)

  const key = stories.map(s => s._id).join('-')

  return (
    <Grid
      key={key}
      container
      spacing={2}
      direction="row"
      justify="space-between"
      alignItems="flex-start"
      cols={2}
    >
      { stories }
    </Grid>
  )
}

export default NonFeaturedStoriesList
